module.exports = __webpack_public_path__ + "static/media/meetup.54da01d3.png";